import React from 'react';
import {Col, Row} from 'react-bootstrap';
import {Errors} from 'react-redux-form';
import Number from '../../../../common/form/spinner';
import TextInput from '../../../../common/form/elements/text-input';

const BandTarget = props => (
  <div>
    <Row>
      <Col md={2}>
        <h4>Band {props.line_number} target:</h4>
      </Col>
      <Col md={1}>
        <h4>between</h4>
      </Col>
      <Col md={1}>
        <Number
          model={`deep.stock_it.levels.${props.id}.band_${props.line_number}_target_from`}
          value={props.target_from}
          min={0}
        />
      </Col>
      <Col md={1}>
        <h4>and</h4>
      </Col>
      <Col md={1}>
        <Number
          model={`deep.stock_it.levels.${props.id}.band_${props.line_number}_target_to`}
          value={props.target_to}
          min={0}
        />
      </Col>
      <Col md={2}>
        <h4>Points at band {props.line_number}</h4>
      </Col>
      <Col md={4}>
        <TextInput
          model={`.levels.${props.id}.band_${props.line_number}_target_points`}
          placeholder='Enter the number of points to display at this banding'
          controlId={`pointsAtBand${props.line_number}`}
        />
      </Col>
    </Row>
    <Row>
      <Errors
        className="errors"
        model={`${props.model}.level_${props.id}_band_${props.line_number}_target_from`}
        show
        dynamic
      />
    </Row>
    <Row>
      <Errors
        className="errors"
        model={`${props.model}.level_${props.id}_band_${props.line_number}_target_to`}
        show
        dynamic
      />
    </Row>
    <Row>
      <Errors
        className="errors"
        model={`${props.model}.level_${props.id}_band_${props.line_number}_target_points`}
        show
        dynamic
      />
    </Row>
  </div>
);

export default BandTarget;



// WEBPACK FOOTER //
// ./src/components/admin/objectives/stock_it/add-stock-its/band-target.jsx